module.exports = new __parcel__URL__("star_wolvez_game_logo.f3b7c3ac.png").toString();